import { defaultDateLib } from "../classes/DateLib.js";
/**
 * Format the month number for the dropdown option label.
 *
 * @defaultValue The localized month name
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
export function formatMonthDropdown(month) {
  let dateLib = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDateLib;
  return dateLib.format(month, "LLLL");
}